<div class="my-3 my-md-5">
    <div class="container-fluid">
        <h1 class="page-title">Member's List</h1>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="row mb-2 mt-2">
                        <div class="col-sm-3 mt-2"><input class="form-control" [(ngModel)]="search" type="text" placeholder="Search" /></div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Circle" [(ngModel)]="circle" multiple>
                                <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-3 mt-2">
                            <mat-select  placeholder="Package Type" [(ngModel)]="pkg_type" multiple>
                                <mat-option value="{{ptype.id}}" *ngFor="let ptype of package_type">{{ptype.plan_name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="BDs" [(ngModel)]="nco_bds" multiple #itemSelect="ngModel" (click)="setSearchValue('bds')">
                                <input class="mySearchInput"
                                #bd_search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'bds')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="bd_search">
                                <mat-option value="{{nc_bds.id}}" *ngFor="let nc_bds of normal_corporate_bds">{{nc_bds.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Payment Mode" [(ngModel)]="pmode" multiple>
                                <mat-option value="{{pmt_mode.value}}" *ngFor="let pmt_mode of payment_mode">{{pmt_mode.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-3 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter a date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate #dateRangeStart placeholder="Start date">
                                    <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate()">clear</mat-icon>
                        </div>
                        <div class="col-sm-3 mt-2">
                            <button type="button" class="btn btn-primary mb-4" (click)="loadmembers(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                            <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                        </div>
                    </div>
                    
                </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-7 p-3">
                    
                    <button type="button" class="btn btn-success" [disabled]="loading" (click)="loadmembers(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>
                    <button type="button" class="btn btn-success ml-2" [disabled]="loading" (click)="exportMemberData()"><i class="fa fa-file-excel"></i> Export List</button>

                    <a  routerLink="/add-member-transaction" class="btn btn-success ml-2">
                        <i class="fa fa-plus" aria-hidden="true"></i> Add Transaction
                    </a>

                    <span *ngIf="userId=='89' || userId=='167'">
                    <button class="btn btn-success text-white ml-2" [disabled]="loading" (click)="showModalUploadPlanTransaction()"><i class="fa fa-file-excel"></i> Import Plan Transaction</button> <br/>
                    <a href="{{sc3Url}}crm/upload_package_transaction_data.csv" target="_blank">Sample CSV for Plan Transaction</a>
                    </span>
                </div>
                <div class="col-sm-5"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <!-- <th>Mobile</th> -->
                        <th>Email</th>
                        <th>Package</th>
                        <th>Payment Mode</th>
                        <th>Billed Amount</th>
                        <th>City Details</th>
                        <th>BD</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let member of memberList;let index = index;">
                        <td >{{(pageIndex*perpage)+index+1}}</td>
                        <td >{{member.name}}</td>
                        <!-- <td >{{member.mobile}}</td> -->
                        <td >{{member.email}}</td>
                        <td >{{member.plan_name}}</td>
                        <td >
                            {{member.payment_mode | titlecase}}
                        </td>
                        <td >{{member.billed_amount}}</td>
                        <td >
                            <b>City: </b>{{member.city_name}}<br />
                            <b>Circle: </b>{{member.circle_name}}
                        </td>
                        <td >
                            <span *ngIf="!member.bd_name && member.formbd_name"><b>Share By:</b>{{member.formbd_name}}</span>

                            <span *ngIf="!member.formbd_name && member.bd_name"><b>Share By:</b>{{member.bd_name}} 
                            <span *ngIf="member.category_name">({{member.category_name}})</span></span>
                            
                            <span *ngIf="!member.bd_name && !member.formbd_name">NA</span>
                        </td>
                        <td>
                            {{member.transaction_date*1000 | date: 'dd/MM/yyyy'}}
                            <!-- <span>{{member.transaction_date*1000 | date: 'yyyy/MM/dd HH:mm:ss'}}</span> -->
                        </td>
                    </tr>
                    <tr *ngIf="loading">
                        <td colspan="7" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>
                    <tr *ngIf="loaded && !memberList.length">
                        <td colspan="7" ><i class="far fa-frown"></i> No member data found</td>
                    </tr>
                </tbody>
            </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>
<div class="modal fade" id="myModalPlanTransaction" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Plan transaction Data </h4>
          <button type="button" class="close" (click)="hideModalUploadPlanTransaction()"></button>
        </div>
        <!-- Modal body -->
          <div class="modal-body">
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-12 text-danger">NOTE:</div>
                    <div class="col-sm-12">****Transaction Date Format: MM/DD/YYYY HH:MM AA</div>
                    <div class="col-sm-12">****Mobile, Email & Payment ID column will not be blank.</div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <label class="col-sm-12">Upload CSV</label>
                    <input [disabled]="submitted" type="file" #csvUploadTransactionData (change)="selectFileForUploadPlanTransaction($event)" class="form-control" />
                </div>
                <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
            </div>
            <div class="form-group" [innerHTML]="uploaded_msg | safe:'html'">
            
            </div>
        </div>
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModalUploadPlanTransaction()">Close</button>
        </div>
      </div>
    </div>
</div>